module.exports = __webpack_public_path__ + "img/bolgheri.d01e8af3.jpg";